import { Component, Input } from '@angular/core';

@Component({
  selector: 'pt-auth-img-area',
  template: `
    <div class='d-flex flex-column h-100 p-3'>
      <div style='width: 120px' *ngIf="showVDTLogo">
        <img class='w-100' src='assets/images/VDT_original.png'>
      </div>
      <div class='d-flex w-100 h-100 justify-content-center align-items-center' *ngIf="showPTLogo">
        <div>
          <img style='margin-bottom: 100px; width: 400px' src='assets/images/static-auth-image.png'>
        </div>
      </div>
    </div>
  `
})
export class AuthImageAreaComponent {
  @Input() showVDTLogo = true;
  @Input() showPTLogo = true;
}
